import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-contract-duration',
    templateUrl: './contract-duration.component.html',
    styleUrls: ['./contract-duration.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractDurationComponent implements OnInit {
  constructor() {}

  @Input() set data(value: any) {
    if (value) {
      this.days = value.days ? value.days : 0;
      this.months = value.months ? value.months : 0;
      this.years = value.years ? value.years : 0;
    }
  }

  days: number = 0;
  months: number = 0;
  years: number = 0;

  ngOnInit() {}
}
